import styled from '@emotion/styled';

const Wrapper = styled('div')`
  border-radius: 10px;
  display: flex;
  max-width: 834px;
  width: 834px;
  .ReactModal__Content {
    border-radius: 12px;
  }
  @media screen and (max-width: 840px) {
    max-width: 640px;
  }
  @media screen and (max-width: 680px) {
    max-width: 540px;
  }
  @media screen and (max-width: 540px) {
    max-width: 500px;
    min-width: 425px;
  }
`;

export default Wrapper;
